import { render } from "./OverlayDemo.vue?vue&type=template&id=1e24abd0&scoped=true"
import script from "./OverlayDemo.vue?vue&type=script&lang=js"
export * from "./OverlayDemo.vue?vue&type=script&lang=js"

import "./OverlayDemo.vue?vue&type=style&index=0&id=1e24abd0&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/eAzC_LUi/0/econsultingsistemas/certificadorweb/certificador-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e24abd0"]])

export default __exports__